
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="/Logo_Cashflow_VIP.svg"
              alt="CashFlow VIP"
              className="h-24 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-white hover:text-vip-gold transition-colors duration-300 relative group font-medium">
              Inicio
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-vip-gold transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              to="/servicios"
              className="text-white hover:text-vip-gold transition-colors duration-300 relative group font-medium"
            >
              Servicios
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-vip-gold transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link to="/nuestra-historia" className="text-white hover:text-vip-gold transition-colors duration-300 relative group font-medium">
              Nuestra Historia
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-vip-gold transition-all duration-300 group-hover:w-full"></span>
            </Link>
            {/* <Link to="/casos-exito" className="text-white hover:text-vip-gold transition-colors duration-300 relative group font-medium">
              Casos de Éxito
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-vip-gold transition-all duration-300 group-hover:w-full"></span>
            </Link> */}
            <Link to="/eventos" className="text-white hover:text-vip-gold transition-colors duration-300 relative group font-medium">
              Eventos
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-vip-gold transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link to="/contacto" className="text-white hover:text-vip-gold transition-colors duration-300 relative group font-medium">
              Contacto
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-vip-gold transition-all duration-300 group-hover:w-full"></span>
            </Link>
          </nav>

          {/* Contact Actions */}
          <div className="hidden lg:flex items-center space-x-4">
            {/* Phone */}
            <a
              href="tel:+13056840894"
              className="flex items-center justify-center w-10 h-10 bg-gray-800 hover:bg-gray-7 rounded-full transition-colors duration-300"
              title="Llamar: +1 (305) 684-0894"
            >
              <i className="ri-phone-line text-white text-lg"></i>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/13056840894"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-10 h-10 bg-green-600 hover:bg-green-7 rounded-full transition-colors duration-300"
              title="WhatsApp"
            >
              <i className="ri-whatsapp-line text-white text-lg"></i>
            </a>

            {/* CTA Button */}
            <a
              href="https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0"
              className="bg-gradient-to-r from-vip-gold to-vip-gold-dark hover:from-vip-gold-dark hover:to-vip-gold text-black px-6 py-2.5 rounded-full font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-vip-gold/25 whitespace-nowrap"
            >
              Agenda Evaluación
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden flex items-center justify-center w-10 h-10 bg-gray-800 hover:bg-gray-7 rounded-lg transition-colors duration-300"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-white text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden bg-gray-900/95 backdrop-blur-md border-t border-gray-800 py-4">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-white hover:text-vip-gold transition-colors duration-300 px-4 py-2 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Inicio
              </Link>
              <Link
                to="/servicios"
                className="text-white hover:text-vip-gold transition-colors duration-300 px-4 py-2 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Servicios
              </Link>
              <Link
                to="/nuestra-historia"
                className="text-white hover:text-vip-gold transition-colors duration-300 px-4 py-2 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Nuestra Historia
              </Link>
              {/* <Link 
                to="/casos-exito" 
                className="text-white hover:text-vip-gold transition-colors duration-300 px-4 py-2 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Casos de Éxito
              </Link> */}
              <Link
                to="/eventos"
                className="text-white hover:text-vip-gold transition-colors duration-300 px-4 py-2 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Eventos
              </Link>
              <Link
                to="/contacto"
                className="text-white hover:text-vip-gold transition-colors duration-300 px-4 py-2 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Contacto
              </Link>

              {/* Mobile Contact Actions */}
              <div className="flex items-center space-x-4 px-4 pt-4 border-t border-gray-800">
                <a
                  href="tel:+13056840894"
                  className="flex items-center justify-center w-10 h-10 bg-gray-800 hover:bg-gray-7 rounded-full transition-colors duration-300"
                >
                  <i className="ri-phone-line text-white text-lg"></i>
                </a>
                <a
                  href="https://wa.me/13056840894"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-10 h-10 bg-green-600 hover:bg-green-7 rounded-full transition-colors duration-300"
                >
                  <i className="ri-whatsapp-line text-white text-lg"></i>
                </a>
                <a
                  href="https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0"
                  className="bg-gradient-to-r from-vip-gold to-vip-gold-dark hover:from-vip-gold-dark hover:to-vip-gold text-black px-4 py-2 rounded-full font-semibold transition-all duration-300 text-sm"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Agenda Evaluación
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
